<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      ref="grid"
      :selectionEnabled="false"
    ></dx-grid>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data: () => ({
    url: "",
    title: "ManageEngine Acknowledges",
    actions: [],
    columns: [
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Value",
        field: "value",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Display Value",
        field: "displayValue",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    this.actions.push({
      text: "Sync Acknowledges",
      action: this.syncAcknowledges,
    });
    this.actions.push({
      text: "Edit Acknowledges on ManageEngine",
      action: this.openManageEngineAcknowledges,
    });
  },
  methods: {
    openManageEngineAcknowledges() {
      window.open(
        "https://utaw.sdpondemand.manageengine.com/app/itdesk/AdminDetails.cc?forwardTo=reqUDF",
        "_blank"
      );
    },
    async syncAcknowledges() {
      try {
        await this.$http.post(
          "api/ManageengineAcknowledges/SyncManageEngineAcknowledges"
        );
      } catch (error) {
        this.$notify({
          group: "notification",
          text: "Error syncing acknowledges",
          type: "error",
        });
        return;
      }
      this.$refs.grid.reloadGrid();
      this.$notify({
        group: "notification",
        text: "Acknowledges synced successfully",
        type: "success",
      });
    },
    async beforeSetupGrid() {
      this.url = "ManageengineAcknowledges";
    },
  },
};
</script>
